import React from 'react';

const Home = () => {
  return (
    <div className="container mt-4">
      <h1>Bienvenido al CRM de Ventas</h1>
      <p>Gestiona usuarios, ventas, pagos y comisiones desde aquí.</p>
    </div>
  );
};

export default Home;